import { createRouter, createWebHistory } from 'vue-router';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import { initializationGuard } from '@/app/router/guards/initialization.js';
import { middlewareGuard } from '@/app/router/guards/middleware.js';
import { permissionsGuard } from '@/app/router/guards/permissions.js';
import { bugsnagNavigationTracker } from '@/app/router/guards/bugsnag.js';
import { routerErrorHandler } from '@/app/router/guards/errorHandling.js';
import { closeMobileSidebar } from '@/app/router/guards/mobileSidebar.js';
import { trackPreviousRoute } from '@/app/router/guards/trackPreviousRoute.js';
import { loadModuleRoutes } from '@/app/router/loadModuleRoutes.ts';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // Module routes get auto-loaded
        ...loadModuleRoutes(),

        // Error routes
        {
            path: '/unauthorized',
            name: 'unauthorized',
            component: () => import('@/app/pages/unauthorized.vue'),
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated],
            },
        },

        // Redirect all unmatched routes
        { path: '/:pathMatch(.*)*', redirect: '/' },
    ],
});

router.beforeEach(initializationGuard);
router.beforeEach(middlewareGuard);
router.beforeEach(permissionsGuard);
router.beforeEach(trackPreviousRoute);
router.afterEach(bugsnagNavigationTracker);
router.afterEach(closeMobileSidebar);
router.onError(routerErrorHandler);

export default router;
